import axios from '../request/http';

const Login = {
    // 获取验证码
    getCode() {
        return axios.get("/hemei-admin/login/captcha");
    },
    // 登录
    login(params) {
        return axios.get("/hemei-admin/login/login", { params });
    },
    // 获取临时 token
    get_sts_token(params) {
        return axios.get("/hemei-admin/base/oss/get_sts_token", { params });
    },
}

export default Login;